<div class="container">
  @if (!loading) {
    <div class="details-section">
      <form #connectionForm="ngForm">
        <div class="form-field">
          <label for="name">Name</label>
          <input
            id="name"
            [value]="user.first_name + ' ' + user.last_name"
            name="name"
            readonly
          />
        </div>
        <div class="form-field">
          <label for="name">Email</label>
          <input id="name" [value]="user.email" name="email" readonly />
        </div>
        <div class="form-field">
          <label for="name">Connection</label>
          <a
            href="javascript:void(0)"
            (click)="onConnectionClick(user.connection_display_name)"
            class="connection-tag"
            [style]="{
              'background-color': tagColour,
              color: '#000',
            }"
            >{{ user.connection_display_name }}</a
          >
        </div>
      </form>
    </div>

    @if (user.connection_display_name.toLowerCase() !== "sme") {
      <section
        class="groups-section"
        [class.collapsed]="!isUserPermissionSectionExpanded"
      >
        <div
          class="section-header"
          role="button"
          tabindex="0"
          (click)="toggleUserPermissionSection()"
          (keydown.enter)="toggleUserPermissionSection()"
          (keydown.space)="toggleUserPermissionSection()"
        >
          <div class="header-title">
            @if (isUserPermissionSectionExpanded) {
              <div class="chevron">
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                  />
                </svg>
              </div>
            } @else {
              <div class="chevron">
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                  />
                </svg>
              </div>
            }
            <h2>User Permissions</h2>
          </div>
          <span class="group-count"
            >{{ permissionsEnabledCount }}/{{
              permissions.custom_permissions.length
            }}
            permissions</span
          >
        </div>
        @if (isUserPermissionSectionExpanded) {
          <div class="groups-list">
            @for (
              customPermission of permissions.custom_permissions;
              track customPermission;
              let index = $index
            ) {
              <div class="group-item">
                <span class="group-name">{{ customPermission.name }}</span>
                <label class="toggle">
                  <input
                    type="checkbox"
                    [(ngModel)]="userPermissionsMap[customPermission.id]"
                    (change)="
                      onUserPermissionChange(customPermission.id, $event)
                    "
                  />
                  <span class="slider"></span>
                </label>
              </div>
            }
          </div>
        }
      </section>
    }

    <section class="groups-section" [class.collapsed]="!isExpandedUserSessions">
      <div
        class="section-header"
        role="button"
        tabindex="0"
        (click)="toggleSection()"
        (keydown.enter)="toggleSection()"
        (keydown.space)="toggleSection()"
      >
        <div class="header-title">
          @if (isExpandedUserSessions) {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                />
              </svg>
            </div>
          } @else {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                />
              </svg>
            </div>
          }
          <h2>Session Details</h2>
        </div>
      </div>
      @if (isExpandedUserSessions) {
        <app-session-details [userId]="user.id"></app-session-details>
      }
    </section>
  } @else {
    <div class="details-section">
      <div class="skeleton-box"></div>
    </div>
    <section class="groups-section">
      <div class="skeleton-box"></div>
    </section>
  }
</div>
